import { Check } from 'react-feather'
import styled from 'styled-components'
import { toRem, fontType,mediaQuery, transition } from '../../styles/functions'

export const Wrapper = styled.label`
	display: flex;
	flex-direction: row;
	align-items: center;
	position: relative;
`

export const CheckBoxWrapper = styled.label`
	/* flex: 1; */
	display: block;
	cursor: pointer;
	position: relative;
	width: 25px;
	height: 25px;
	margin-right: 16px;
`

export const ErrorMessage = styled.p`
	position: absolute;
	top: -22px;
	font-size: ${toRem(16)};
	color: ${(props) => props.theme.COLORS.ORANGE_ERROR};
	text-transform: uppercase;
	${fontType(2)};
`

export const CheckMark = styled(Check)`
	position: absolute;
	top: 0;
	left: 0;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 22px;
	height: 22px;
	padding: 8px;
	background: ${(props) => props.theme.COLORS.GREY};
	border: 1px solid ${(props) => props.theme.COLORS.GREY};
	border-radius: 10px;
	color: transparent;

	${transition()}
`

export const CheckBox = styled.input`
	position: absolute;
	opacity: 0;
	height: 0;
	width: 0;

	&:checked {
		+ ${CheckMark} {
			background: ${(props) => props.theme.COLORS.BLACK};
			border: 1px solid transparent;
			padding: 2px;
			color: ${(props) => props.theme.COLORS.WHITE};
		}
	}

	/* &[disabled] {
		+ ${CheckMark} {
			border: 1px dashed ${(props) => props.theme.COLORS.ANTAGONISTA_COLOR};
		}
	} */
`

export const Label = styled.label`
	text-align: left;
	font-family: ${fontType(2)};
	font-size: ${toRem(28)};
	color: ${({ theme }) => theme.COLORS.WHITE};
	cursor: pointer;
	font-weight: 300;

	${mediaQuery('xs')(`
	font-size: ${toRem(20)};
	`)}
`
